export const growthLabels = [
  { label: 'P3', color: 'violet' },
  { label: 'P25', color: 'rgba(0, 0, 0, 0.3)' },
  { label: 'P50', color: 'rgba(0, 0, 0, 0.3)' },
  { label: 'P75', color: 'rgba(0, 0, 0, 0.3)' },
  { label: 'P97', color: 'red' },
]
